// Shared strip-manifest helpers for the baked-strip LOD (mobile world view +
// desktop canvas underlay). Strips are baked by scripts/generate-strips.js;
// see docs/testing-mobile.md.

// FNV-1a 32-bit — mirrors scripts/generate-strips.js. Used to validate that a
// baked strip still matches a row's current items; on mismatch callers fall
// back (tint mosaic on mobile, blurhash placeholders on desktop).
export function fnv1a32(str) {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h;
}

// Fetch assets/strips/manifest.json. Resolves null on any failure — every
// caller treats null as "no strips, use fallbacks".
export function fetchStripManifest() {
    return fetch(`${window.JK.baseUrl}/assets/strips/manifest.json`, { cache: 'no-cache' })
        .then(r => (r.ok ? r.json() : null))
        .catch(() => null);
}

// Manifest entry for a layout group, or null if missing/stale. `group` needs
// `key` and `items` (with ids) — the shape both gallery layouts produce.
export function stripEntryFor(manifest, type, group) {
    const entry = manifest?.types?.[type]?.find(e => e.key === group.key);
    if (!entry || entry.count !== group.items.length) return null;
    const idsHash = fnv1a32(group.items.map(i => i.id).join(',')).toString(16).padStart(8, '0');
    return entry.idsHash === idsHash ? entry : null;
}

export function stripUrl(entry) {
    return `${window.JK.baseUrl}/assets/strips/${entry.file}`;
}
